<ng-container *ngIf="{
  info: (productInfo | async),
  analogs: (analogsBZ| async),
  city: (currentCity | async),
  rout: (routeParams | async),
  similar: (similarBZ| async),
  full: (fullInstraction | async)
} as page">
  <div class="page-wrapper">
  <main>

    <div class="product-title-top">
      <p>{{ page?.info?.name }}</p>
    </div>

    <div class="crumbs-wrapper" #topPosition>
      <nav class="crumbs-info-drag">
          <span>
            <a (click)="clearSearchState()" [routerLink]="getHomeLink()"
               [textContent]="'search-for-drugs' | transloco"></a>
          </span>
          <ng-container *ngFor="let crumb of page?.info?.crumbs?.filter(crumbsFilter)">
            <span>
              <a [routerLink]="toLinkHrefCustomCatalog(crumb)" [textContent]="crumb?.name" (click)="clearSearchState()"></a>
            </span>
          </ng-container>
      </nav>
    </div>

  <div class="nav-container">
    <div>
      <h1 class="product-name">{{page?.info?.name}}</h1>
    </div>
    <span class="spacer"></span>

    <bz-button *ngIf="!page?.info?.description" (click)="switchTabs(1); scrollToElement('instrustion')"
      class="button" [type]="'#449bd1'" [k]="1" [text]="'instruction' | transloco" [textColor]="'#0A0A0A'"
      [icon]="'sm-prescription.svg'" [content]="'all'" [size]="{w: 70, h: 70}" [radius]="['50%','50%','50%','50%']">
    </bz-button>

    <bz-button class="button" *ngIf="!page?.info?.description" [icon]="'sm-refill.svg'"
      [disabled]="page?.analogs?.length === 0" [hoverTextDisabled]="'noSearchAnalogs' | transloco"
      [type]="'#449bd1'" [content]="'all'" (click)="switchTabs(2); scrollToElement('analogs')"
      [text]="'analogs' | transloco" [textColor]="'#0A0A0A'" [size]="{w: 70, h: 70}"
      [radius]="['50%','50%','50%','50%']" [fontSize]="'12px'">
    </bz-button>
  </div>

  <div class="page__content" #content>
    <ng-container *ngTemplateOutlet="product"></ng-container>
    <ng-container *screen="0">
      <ng-container *ngTemplateOutlet="mainBanner"></ng-container>
    </ng-container>
    <ng-container *ngTemplateOutlet="instrustion"></ng-container>
    <ng-container *ngTemplateOutlet="analogs"></ng-container>
    <ng-container *ngTemplateOutlet="similarProducts"></ng-container>
    <ng-container *ngTemplateOutlet="purchaseProcessAndFaq"></ng-container>
    <ng-container *ngTemplateOutlet="seoRegionLinks"></ng-container>
  </div>

  <ng-template #product>
    <div class="product-container" [ngStyle]="{
        'position': page?.info?.description ? 'relative': '',
        'top': page?.info?.description ? '-10px' : ''}">
      <div class="product">
        <ng-container *ngIf="page?.info?.description">
          <ng-container *ngTemplateOutlet="return"></ng-container>
        </ng-container>
        <ng-container *ngIf="!page?.info?.description">
          <ng-container *ngTemplateOutlet="return"></ng-container>
        </ng-container>

        <div class="image-container">
          <div class="mobile-nav-bar">
            <bz-button *ngIf="!page?.info?.description" (click)="scrollToElement('instrustion')"
              class="button" [type]="colors.second" [text]="('instruction' | transloco)" [textColor]="'#ffffff'"
              [size]="{w: 100, h: 50}" [radius]="['40px',' 0',' 0',' 40px']" [fontSize]="'14px'"></bz-button>
            <bz-button *ngIf="!page?.info?.description && page?.analogs?.length !== 0"
              [hoverTextDisabled]="'noSearchAnalogs' | transloco" (click)="scrollToElement('analogs')" class="button"
              [type]="colors.third" [text]="'analogs' | transloco" [textColor]="'#ffffff'" [size]="{w: 100, h: 50}"
              [radius]="['40px',' 0',' 0',' 40px']" [fontSize]="'14px'"></bz-button>
            <bz-button *ngIf="!page?.info?.description && page?.analogs?.length === 0"
              [disabled]="page?.analogs?.length === 0" [hoverTextDisabled]="'noSearchAnalogs' | transloco"
              [type]="colors.primary" [text]="'analogs' | transloco" [textColor]="'#ffffff'" [size]="{w: 100, h: 50}"
              [radius]="['40px',' 0',' 0',' 40px']" [fontSize]="'14px'"></bz-button>
            <bz-button *ngIf="page?.info?.description" (click)="scrollToElement('instrustion')"
              class="button" [type]="colors.primary" [text]="'depiction' | transloco" [textColor]="'#ffffff'"
              [size]="{w: 100, h: 50}" [radius]="['40px',' 0',' 0',' 40px']" [fontSize]="'14px'"></bz-button>
          </div>
          <ng-container *ngIf="page else ssrNull">

              <info-drag-picture
                [name]="page?.info?.name"
                [image]="page?.info?.image"
                [currentLang]="currentLang"
                (onClickPicture)="resizeMobileImage()"
              ></info-drag-picture>

          </ng-container>
          <ng-template #ssrNull>
            <img class="null-image" style="height: 390px; min-height: 390px;" src="../../../assets/loading-img-ssr.gif"
              alt="Null image">
          </ng-template>

          <div class="price-range-primary">
            <div class="inner-wrapper">
              <span *ngIf="page?.info?.foundInPharm === true">
                {{(page?.info?.productInfo?.priceRange && (page?.info?.productInfo?.priceRange[0]?.toFixed(2))) ? (page?.info?.productInfo?.priceRange[0]?.toFixed(2)) : '0.00'}}
                -
                {{(page?.info?.productInfo?.priceRange && (page?.info?.productInfo?.priceRange[1]?.toFixed(2))) ? (page?.info?.productInfo?.priceRange[1]?.toFixed(2)) : '0.00'}} грн.
              </span>

              <div class="action-column btn-to-pharmcy">
                <ng-container *ngIf="{ product: page } as data">
                  <ng-container *ngIf="page?.info?.foundInPharm  && !page?.info?.otherTowns">
                    <button class="search-in-pharmacies-mobi" (click)="toPharmacies()">
                      {{'select-pharma' | transloco}}
                    </button>
                  </ng-container>

                  <ng-container *ngIf="!page?.info?.foundInPharm  && page?.info?.otherTowns">
                    <button class="search-in-pharmacies-mobi" style="width: 175px; white-space: normal"
                      (click)="toPharmacies(true)">
                      {{'prices-in-other-cities' | transloco}}
                    </button>
                  </ng-container>
                </ng-container>

                <ng-container *ngIf="!page?.info?.foundInPharm && !page?.info?.otherTowns">
                  <button style="background: rgb(163, 163, 163); white-space: normal" class="search-in-pharmacies-mobi">
                    {{'not-found-in-pharma' | transloco}}
                  </button>
                </ng-container>

              </div>

            </div>
          </div>
          <div class="searched" [ngStyle]="{'display': 'flex', 'align-items': 'center', 'justify-content': 'center'}">
            <img class="target-icon" [ngStyle]="{'width': '30px', 'height': '30px'}"
              src="../../../assets/finded-blue-icon.svg" alt="target" [title]="'countOfPharms' | transloco">
            <p *ngIf="page?.info?.foundInPharm === true"
              [ngStyle]="{'font-size': '13px', 'color': '#449bd1'}" class="searched-items">
              {{'searched' | transloco}} в
              {{page?.info?.pharmaciesCount}}
              аптеках</p>
            <p *ngIf="page?.info?.foundInPharm === false"
              [ngStyle]="{'font-size': '13px', 'color': '#449bd1'}" class="searched-items">
              {{'notFindedIn' | transloco}}
              {{'shortCity' | transloco}} {{ page.city }}</p>
          </div>
        </div>

        <div class="pharmacies" [ngStyle]="{'position': 'relative'}">
          <ng-container *ngIf="{
                      product: page
                    } as data">
            <ng-container *ngIf="page?.info?.foundInPharm && !page?.info?.otherTowns">
              <a
                [routerLink]="getRouterLinkToPharmcies() + '/' + page?.rout?.url + '/' + locationService.townEn">
                <button class="search-in-pharmacies">
                  <span class="inner-span">{{'select-pharma' | transloco}}</span>
                </button>
              </a>
            </ng-container>

            <ng-container *ngIf="!page?.info?.foundInPharm && page?.info?.otherTowns">
              <a (click)="toOtherPharmacies()" othersClickCatcher>
                <button class="search-in-pharmacies">
                  <span class="inner-span">{{'prices-in-other-cities' | transloco}}</span>
                </button>
              </a>
            </ng-container>

            <ng-container *ngIf="!page?.info?.foundInPharm && !page?.info?.otherTowns">
              <button style="background: rgb(163, 163, 163);" class="search-in-pharmacies">
                <span class="inner-span">{{'in-pharmcy' | transloco}}</span>
              </button>
            </ng-container>
          </ng-container>

          <span class="price-range-desktop" *ngIf="page?.info?.foundInPharm === true">
            {{(page?.info?.productInfo?.priceRange && (page?.info?.productInfo?.priceRange[0]?.toFixed(2))) ? (page?.info?.productInfo?.priceRange[0]?.toFixed(2)) : '0.00'}}
            -
            {{(page?.info?.productInfo?.priceRange && (page?.info?.productInfo?.priceRange[1]?.toFixed(2))) ? (page?.info?.productInfo?.priceRange[1]?.toFixed(2)) : '0.00'}} грн.
          </span>
        </div>

        <div class="searched-desktop">
          <img class="target-icon" src="../../../assets/finded-blue-icon.svg" alt="target"
            [title]="'countOfPharms' | transloco">
          <p *ngIf="page?.info?.foundInPharm === true" class="searched-items">{{'searched' | transloco}} в
            {{page?.info?.pharmaciesCount}} аптеках</p>
          <p *ngIf="page?.info?.foundInPharm === false" class="searched-items">{{'notFindedIn' | transloco}}
            {{'shortCity' | transloco}} {{ page.city }}</p>
        </div>

        <div class="product-actions">
          <div class="action-column" *ngIf="page?.info?.foundInPharm">
            <bz-button class="list" (click)="addProductTolist(page.info);" [type]="'transparent'" [k]="1.45"
              [text]="!page?.info?.isList ? ('in-list' | transloco) : ('already-in-list' | transloco)"
              [textColor]="!page?.info?.isList ? '#292929bf' : colors.second" [icon]="'list.svg'"
              [defaultIconColor]="!page?.info?.isList ? '#292929bf' : colors.second" [content]="'all'"
              [size]="{w: 60, h: 45}" [radius]="false">
            </bz-button>
          </div>
          <div class="action-column" *ngIf="page?.info?.id">
            <bz-button class="favorite" (click)="addProductToFavorite(page?.info);" [type]="'transparent'" [k]="1.45"
              [text]="page?.info?.isFavorite ? ('already-in-favorite' | transloco) : ('in-favorite' | transloco)"
              [textColor]="page?.info?.isFavorite ? colors.second : '#292929bf'"
              [icon]="page?.info?.isFavorite ? 'sm-heart-inner.svg' : 'sm-heart.svg'"
              [defaultIconColor]="page?.info?.isFavorite ? colors.second : '#292929bf'" [content]="'all'"
              [size]="{w: 60, h: 45}" [radius]="false">
            </bz-button>
          </div>
          <div class="action-column" style="position: relative;" *ngIf="page?.info?.id">
            <bz-button class="list" (click)="openSocialBtn($event);" [type]="'transparent'" [k]="1.45"
              [text]="'share' | transloco" [textColor]="'#292929bf'" [icon]="'icons/share-icon.svg'"
              [defaultIconColor]="'#292929bf'" [content]="'all'" [size]="{w: 60, h: 45}" [radius]="false">
            </bz-button>

            <share-buttons (bzOutside)="openSocialBtn()" class="btn-share-social-popup" *ngIf="openSocialPopup"
              [theme]="'circles-light'"
              [include]="['twitter','telegram','messenger','whatsapp','viber','sms','email','copy']" [show]="8"
              [size]="0" [url]="getCurrentLinkAdress()" [image]="page?.info?.image" [autoSetMeta]="false">
            </share-buttons>

          </div>
          <span class="spacer hide-on-desktop"></span>
        </div>
      </div>

      <div class="table">
        <div class="heading-wrapper">
          <h2 class="table-heading">{{ page?.info?.name }}: {{ 'product-characteristics' | transloco }}</h2>
        </div>

          <info-drag-table-info
            [info]="page?.info?.productInfo"
            (onEventClearSearchState)="clearSearchState()"
            (onEventLinkATHToSearch)="linkATHToSearch($event)"
          ></info-drag-table-info>

        <div class="heading-wrapper" *ngIf="!page?.info?.description">
          <h2 class="table-heading">{{ 'reception.features' | transloco }} {{ page?.info?.name }}</h2>
        </div>

        <info-drag-table-permission
          *ngIf="!(page?.info?.description) && page?.info?.productInfo?.permissions"
          [permissions]="page.info.productInfo.permissions"
        ></info-drag-table-permission>

      </div>
    </div>
    <bz-instruction-author
      [seoControl]="page?.info?.seoControl"
      [addExtraMarginBottom]="!!page?.info?.description">
    </bz-instruction-author>
  </ng-template>

  <ng-template #mainBanner>
    <div class="main-banner" *ngIf="(page.info.infoDrugBanner?.main) as adBanner">
      <a [href]="adBanner.redirectTo">
        <picture class="banner-picture">
          <source [srcset]="bannerImages + adBanner.img + '.webp'" type="image/webp">
          <img bz-image [src]="bannerImages + 'png/' + adBanner.img + '.png'" [title]="'Банер'" [alt]="'Банер'">
        </picture>
      </a>
    </div>
  </ng-template>

  <ng-template #instrustion>
    <div [ngClass]="{'sticky-header-mobile': screenDetectedService.isMobile()}" class="button-back-mobile">
      <p class="product-name hide-on-mobile">{{page?.info?.name}}</p>
    </div>
    <ng-container *ngIf="!page?.info?.description">
      <h2 #instrScroll *ngIf="shortInsctruction" id="instrustion" class="short-ditails-title"
        [ngStyle]="{'padding-top': page?.info?.description ? '0px' : '40px'}">
        {{ 'short-instructions-for-use' | transloco }} для {{ page?.name }}
      </h2>
      <h2 #instrScroll *ngIf="!shortInsctruction" id="instrustion" class="short-ditails-title"
        [ngStyle]="{'padding-top': page?.info?.description ? '0px' : '75px'}">
        {{ 'instructions-for-use' | transloco }} для {{ page?.name }}
      </h2>
    </ng-container>
    <ng-container *ngIf="page?.description">
      <h2 #instrScroll id="instrustion" class="short-ditails-title"
        [ngStyle]="{'padding-top': page?.info?.description ? '0px' : '75px'}">
        {{ 'depiction' | transloco }} для {{ page?.name }}
      </h2>
    </ng-container>
    <ng-container>
      <div class="ditails-buttons">
        <div *ngIf="!page?.info?.description && isLong" class="buttons-group"
          (click)="onButtonGroupClick($event)">
          <button (click)="backToShortInstruction(); moveBlockToView(0)" class="toggle-button" type="button"
            value="0">{{'composition' | transloco}}</button>
          <button (click)="backToShortInstruction(); moveBlockToView(1)" class="toggle-button" type="button"
            value="1">{{'testimony' | transloco}}</button>
          <button (click)="backToShortInstruction(); moveBlockToView(2)" class="toggle-button" type="button"
            value="2">{{'contraindications' | transloco}}</button>
          <button (click)="backToShortInstruction(); moveBlockToView(3)" class="toggle-button" type="button"
            value="3">{{'usage' | transloco}}</button>
        </div>
        <span class="spacer"></span>
        <img (click)="printPage()" class="icon-button" src="../../../assets/icons/print-icon.svg"
          alt="print" [title]="'print' | transloco">
        <div style="position: relative;">
          <img (click)="openSocialBtnInsruction()" class="icon-button" src="../../../assets/icons/share-icon.svg"
            alt="share" [title]="'share' | transloco">
          <share-buttons [ngStyle]="{'right': page?.info?.description ? '15px' : '-20px'}"
            (bzOutside)="openSocialBtnInsruction()" class="btn-share-social-popup btn-share-social-popup-instrution"
            style="top: 30px;" *ngIf="openSocialPopupInstruction" [theme]="'circles-light'"
            [include]="['twitter','telegram','messenger','whatsapp','viber','sms','email','copy']" [show]="8"
            [size]="0" [url]="getCurrentLinkAdress() + (!shortInsctruction ? '?i=full' : '?i=short')"
            [image]="page?.info?.image" [autoSetMeta]="false">
          </share-buttons>
        </div>

        <button *ngIf="isLong && !page?.info?.description" class="long-ditails"
          (click)="toggleInstrution()">{{'long-instruction' |
          transloco}}</button>
        <button *ngIf="!isLong && !page?.info?.description" class="long-ditails"
          (click)="toggleInstrution(); ">{{'short-insctruction' |
          transloco}}</button>
      </div>
      <ng-container *screen="1">
        <ng-container *ngTemplateOutlet="mainBanner"></ng-container>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="!page?.info?.description">
      <div *ngIf="shortInsctruction" class="tabs-wapper">
        <div class="tab composition" [ngClass]="{'active-background' : buttons.first === toggleBackground}"
          #composition>
          <div class="top">
            <img class="flask-icon" src="../../../assets/icons/flask-icon.svg" alt="composition"
              [title]="'composition' | transloco">
            <h3 class="icon-name">{{'composition' | transloco}}</h3>
          </div>
          <div class="bottom">
            <p class="bot-desription" [innerHTML]="page?.info?.shortDescription?.composition"></p>
          </div>
        </div>

        <div class="tab testimony" [ngClass]="{'active-background' : buttons.second === toggleBackground}" #testimony>
          <div class="top">
            <img class="flask-icon" src="../../../assets/icons/leaf-icon.svg" alt="testimony"
              [title]="'testimony' | transloco">
            <h3 class="icon-name">{{'testimony' | transloco}}</h3>
          </div>
          <div class="bottom">
            <p class="bot-desription" [innerHTML]="page?.info?.shortDescription?.indications"></p>
          </div>
        </div>

        <div class="tab contraindications" [ngClass]="{'active-background' : buttons.third === toggleBackground}"
          #contraindications>
          <div class="top">
            <img class="flask-icon" src="../../../assets/icons/contraindications-icon.svg" alt="composition"
              [title]="'contraindications' | transloco">
            <h3 class="icon-name">{{'contraindications' | transloco}}</h3>
          </div>
          <div class="bottom">
            <p class="bot-desription" [innerHTML]="page?.info?.shortDescription?.contraindications"></p>
          </div>
        </div>

        <div class="tab usage" [ngClass]="{'active-background' : buttons.fourth === toggleBackground}" #usage>
          <div class="top">
            <img class="flask-icon" src="../../../assets/icons/usage-icon.svg" alt="Usage"
              [title]="'usage' | transloco">
            <h3 class="icon-name">{{'usage' | transloco}}</h3>
          </div>
          <div class="bottom">
            <p class="bot-description" [innerHTML]="page?.info?.shortDescription?.usage"></p>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="!page?.info?.description">
      <div class="long-instruction" *ngIf="!shortInsctruction">
        <div class="long-instruction-anchors">
          <div class="left">
            <p (click)="toAnchorFromLongInstruction('s1_Sklad')">{{ 'info.drug.instruction.s1' | transloco }}</p>
            <p (click)="toAnchorFromLongInstruction('s2_Likar_forma')">{{ 'info.drug.instruction.s2' | transloco }}</p>
            <p (click)="toAnchorFromLongInstruction('s3_farm_grupa')">{{ 'info.drug.instruction.s3' | transloco }}</p>
            <p (click)="toAnchorFromLongInstruction('s4_farm_vlastiv')">{{ 'info.drug.instruction.s4' | transloco }}</p>
            <p (click)="toAnchorFromLongInstruction('s5_Pokazan')">{{ 'info.drug.instruction.s5' | transloco }}</p>
            <p (click)="toAnchorFromLongInstruction('s6_Protipokazan')">{{ 'info.drug.instruction.s6' | transloco }}</p>
            <p (click)="toAnchorFromLongInstruction('s7_Vzaemo_inshi_lik_zas')">{{ 'info.drug.instruction.s7' | transloco }}</p>
            <p (click)="toAnchorFromLongInstruction('s8_Osobl_zastos')">{{ 'info.drug.instruction.s8' | transloco }}</p>
          </div>
          <div class="right">
            <p (click)="toAnchorFromLongInstruction('s9_Sposib_zastos')">{{ 'info.drug.instruction.s9' | transloco }}</p>
            <p (click)="toAnchorFromLongInstruction('s10_Peredoz')">{{ 'info.drug.instruction.s10' | transloco }}</p>
            <p (click)="toAnchorFromLongInstruction('s11_Pobich')">{{ 'info.drug.instruction.s11' | transloco }}</p>
            <p (click)="toAnchorFromLongInstruction('s12_Termin')">{{ 'info.drug.instruction.s12' | transloco }}</p>
            <p (click)="toAnchorFromLongInstruction('s13_Umovi_zber')">{{ 'info.drug.instruction.s13' | transloco }}</p>
            <p (click)="toAnchorFromLongInstruction('s14_Upakovka')">{{ 'info.drug.instruction.s14' | transloco }}</p>
            <p (click)="toAnchorFromLongInstruction('s15_Kategor_vidpusku')">{{ 'info.drug.instruction.s15' | transloco }}</p>
            <p (click)="toAnchorFromLongInstruction('s16_Virobnik')">{{ 'info.drug.instruction.s16' | transloco }}</p>
          </div>
        </div>
        <p class="ditails-list" [innerHTML]="page?.full?.data | safeHTML"></p>
      </div>
    </ng-container>
    <ng-container *ngIf="page?.info?.description">
      <div class="long-instruction">
        <p class="ditails-list" [innerHTML]="page?.info?.description | safeHTML"></p>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #analogs>
    <ng-container *ngIf="page?.analogs?.length !== 0">

      <div #analgScroll id="analogs" class="analogs" *ngIf="!page?.info?.description">
        <div class="sticky-header-mobile">
          <h2 class="analogs-title">{{'analogs' | transloco}} для {{ page?.info?.name }}</h2>
        </div>
        <div class="products-wrapper"
          [ngStyle]="{'justify-content': screenDetectedService.isDesktop() && page?.analogs?.length == 2 ? 'space-around' : ''}">
          <bz-product
            *ngFor="let item of page?.analogs; trackBy: trackById"
            style="margin: 15px 0"
            class="analog-item"
            [BzProduct]="item"
            [isBtnToMenu]="false"
            (onClickProduct)="redirectToProductInfo(item)">
          </bz-product>
        </div>
        <div (click)="toSearchAnalogs(page?.info)" class="still" [textContent]="'show_more' | transloco"></div>
      </div>

    </ng-container>

  </ng-template>

  <ng-template #seoRegionLinks>
    <div class="seo-regions-text">
      <p>
        {{ 'buy' | transloco }}
        {{ page?.info?.name }}
        {{ 'in-ukr-pharmacies' | transloco }}
        {{ 'book' | transloco }}
        {{ page?.info?.name }}
        {{ 'such-cities' | transloco }}
        <ng-container *ngFor="let city of page?.info?.more_towns; let last = last;">
          <a class="city-link" [routerLink]="getRouterLinkToPharmcies() + '/' + page?.rout?.url + '/' + city?.nameEn">
            {{ city.name }}
            <span style="padding-right: 5px;" *ngIf="!last">,</span>
          </a>
        </ng-container>
        {{ 'and-others-ukr-cities' | transloco }}
      </p>
    </div>
  </ng-template>

  <ng-template #similarProducts>
    <ng-container *ngIf="page?.similar?.length > 0">
      <h2 class="similar-products-heading">
        {{ 'buyWith' | transloco }}
        {{ page?.info?.name }}
      </h2>
      <div class="products-wrapper"
        [ngStyle]="{'justify-content': screenDetectedService.isDesktop() && page?.similar?.length == 2 ? 'space-around' : ''}">
        <bz-product
          *ngFor="let item of page?.similar; trackBy: trackById"
          style="margin: 15px 0"
          class="analog-item similar-products"
          [BzProduct]="item"
          [isBtnToMenu]="false"
          (onClickProduct)="redirectToProductInfo(item)">
        </bz-product>
      </div>
    </ng-container>
  </ng-template>

  <ng-template #purchaseProcessAndFaq>
    <bz-faq
      class="product-faqs"
      [faqs]="page?.info?.faq?.faqs"
      [heading]="page?.info?.faq?.h2"
      [text]="page?.info?.faq?.text"
      [setMobileWhiteBackground]="false"
      [banner]="page.info.infoDrugBanner?.additional"
      [footer]="page?.info?.faq?.finalText">
    </bz-faq>
    <bz-help-center
      [heading]="page?.info?.name"
      [items]="page?.info?.howToBuy">
    </bz-help-center>
  </ng-template>

  <div class="seoTextInfoDrag" [ngStyle]="{'padding-top': seoTextInfoDrag ? '15px' : '0px'}">
    <div *AppShellRender class="white-block" style="height: 1080px"></div>
    {{seoTextInfoDrag}}
  </div>
  <ng-template #return>
    <div class="button-back-mobile" [ngClass]="{'sticky-header-mobile': screenDetectedService.isMobile()}">
      <bz-return-btn-arrow (pushBtnReturn)="pushBtnReturn()" class="mobile-btn-back-easy" [easyBack]="true">{{'back' |
        transloco}}
      </bz-return-btn-arrow>
      <p [hidden]="page?.info?.description" class="product-name hide-on-mobile">{{page?.info?.name}}</p>
    </div>
  </ng-template>

  <ng-container *ngIf="resizedMobileImage">
    <div class="image-wrapper-popup">
      <div (click)="closeMobileImage()" style="position: relative;" class="closed-btn close-image">
        <span style="background-color: #000000" class="icon"></span>
      </div>

      <info-drag-picture
        [name]="page?.info?.name"
        [image]="page?.info?.image"
        [currentLang]="currentLang"
        (onClickPicture)="resizeMobileImage()"
      ></info-drag-picture>

    </div>
  </ng-container>
  </main>

  <div class="static-footer">
    <bz-static-footer></bz-static-footer>
  </div>
</div>
</ng-container>
<button class="btnToTop" [ngClass]="{'showBtn' : showScrollBtn}" type="button" (click)="scrollToTop()">
  <span class="icon">ffff</span>
</button>
